"use client";

import { Consent, useConsent } from "@packages/consent";
import { lazy, Suspense, useEffect, useState } from "react";

const GTM = lazy(() =>
  import("@next/third-parties/google").then((module) => ({
    default: module.GoogleTagManager,
  })),
);

export const GoogleTagManager = () => {
  const { consent } = useConsent();
  const [isLoaded, setIsLoaded] = useState(false);
  const [canBeTracked, setCanBeTracked] = useState(false);

  useEffect(() => {
    setIsLoaded(true);
  }, []);

  useEffect(() => {
    setCanBeTracked(
      Array.isArray(consent) &&
        consent.includes(Consent.ANALYTICS) &&
        consent.includes(Consent.ADVERTISING),
    );
  }, [consent]);

  if (!isLoaded) return null;

  if (!canBeTracked) return null;

  return (
    <Suspense>
      <GTM gtmId={process.env.NEXT_PUBLIC_GTM_ID} />
    </Suspense>
  );
};
